const namespace = {
  title: "Caractéristiques",
  noData:
    "Aucune information n'est présentement disponible pour ce quartier. Restez à l'affût des mises à jour pour l'ajout de nouveaux quartiers.",
  sections: {
    transport: {
      title: "Transport",
    },
    services: {
      title: "Services",
    },
    character: {
      title: "Caractère",
    },
  },
} as const;

export default namespace;
